export const REDO_LEFT_ARRAY: number[][] = [
  [1],
  [1],
  [1, 2],
  [1, 2],
  [1, 2, 3],
  [1, 2, 3],
  [1, 2, 3, 4],
  [1, 2, 3, 4],
  [1, 2, 3, 4, 5],
];

export const REDO_RIGHT_ARRAY: number[][] = [
  [1],
  [2],
  [3, 2],
  [4, 3],
  [5, 4, 3],
  [6, 5, 4],
  [7, 6, 5, 4],
  [8, 7, 6, 5],
  [9, 8, 7, 6, 5],
];

export const REDO_START_SECONDS_DEFAULT: number[] = [0, 120, 95, 75];

export const REDO_START_SECONDS_FLAG1: number[] = [0, 0, 170, 200];

export const REDO_GAME_ARRAY_FLAG3: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9];
